import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { OnBehalfIndicator } from 'services/professional/certificates/certificates.interface';
import { ComputedFrom } from '@certemy/common';
import { ON_BEHALF_ACTION_NAMES } from 'constants/certification.constants';

@Component({
  selector: 'cm-step-on-behalf-list',
  templateUrl: 'step-on-behalf-list.component.html',
  styleUrls: ['step-on-behalf-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepOnBehalfListComponent {
  @Input() onBehalfIndicator: OnBehalfIndicator;

  @ComputedFrom('onBehalfIndicator')
  get label() {
    const { first_name, last_name, organization_name } = this.onBehalfIndicator.profile;
    const action = ON_BEHALF_ACTION_NAMES[this.onBehalfIndicator.action];
    return `${first_name} ${last_name} from ${organization_name} has ${action.toLowerCase()} this step`;
  }
}
